import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const AntipodeMap = () => {
    const [userLocation, setUserLocation] = useState(null);
    const [antipodeLocation, setAntipodeLocation] = useState(null);

    useEffect(() => {
        // Leaflet을 이용하여 지도 초기화 및 표시하는 함수
        const initMap = async () => {
            try {
                // 사용자의 위치 가져오기
                const position = await getUserLocation();
                const { latitude, longitude } = position.coords;

                // 사용자 지도 초기화
                const userMap = L.map('user-map').setView([latitude, longitude], 4);
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                }).addTo(userMap);
                L.marker([latitude, longitude])
                    .addTo(userMap)
                    .bindPopup('<b>Your Location</b>')
                    .openPopup();

                // 반대편 지도 계산
                const antipodeLatitude = -latitude;
                let antipodeLongitude = (longitude + 180) % 360;
                if (antipodeLongitude < -180) {
                    antipodeLongitude += 360;
                }

                // 반대편 지도 초기화
                const antipodeMap = L.map('antipode-map').setView(
                    [antipodeLatitude, antipodeLongitude],
                    4
                );
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                }).addTo(antipodeMap);
                L.marker([antipodeLatitude, antipodeLongitude])
                    .addTo(antipodeMap)
                    .bindPopup('<b>Antipode Location</b>')
                    .openPopup();

                // 사용자 위치 정보 업데이트
                setUserLocation({ latitude, longitude });

                // 반대편 위치 정보 업데이트
                setAntipodeLocation({ latitude: antipodeLatitude, longitude: antipodeLongitude });
            } catch (error) {
                console.error('Error fetching user location:', error);
            }
        };

        // 사용자의 위치를 가져오는 함수
        const getUserLocation = () => {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject);
            });
        };

        initMap();
    }, []);

    return (
        <div>
            <h2 style={{ textAlign: 'center' }}>Find Your Antipode</h2>
            <h5 style={{ textAlign: 'center', animation: 'rainbow 2s infinite' }}>
                Made by 규성
            </h5>
            {userLocation && antipodeLocation && (
                <div>
                    <div className="location-info">
                        <h3>Your Location:</h3>
                        <div id="user-map" style={{ height: '400px' }}></div>
                    </div>
                    <div className="location-info">
                        <h3>Antipode Location:</h3>
                        <div id="antipode-map" style={{ height: '400px' }}></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AntipodeMap;
